/**
 * 팔로우 상태 이넘
 */
export enum FollowStatus {
  NONE = 'none', // 팔로우 안 함
  REQUESTED = 'requested', // 팔로우 요청됨
  FOLLOWING = 'following', // 팔로잉 중
}

/**
 * 팔로워 상태 이넘 (팔로워 목록용)
 */
export enum FollowerStatus {
  NONE = 'none', // 팔로우 안 함
  PENDING = 'pending', // 팔로우 요청 대기중
  ACCEPTED = 'accepted', // 팔로우 수락됨 (팔로잉 중)
  REJECTED = 'rejected', // 팔로우 거절됨
}

/**
 * 팔로우 목록 타입 이넘
 */
export enum FollowListType {
  FOLLOWERS = 'followers', // 팔로워 목록
  FOLLOWING = 'following', // 팔로잉 목록
}
